import type * as React from "react";
import { Box, Typography } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";
import { COLORS } from "components/v3/Theme/colors";

export type MembershipInviteHowItWorksStep = {
  body: React.ReactNode;
  icon: string;
  title: string;
};

export type MembershipInviteHowItWorksBlockProps = {
  steps: ReadonlyArray<MembershipInviteHowItWorksStep>;
  sx?: SxProps<Theme>;
};

const CIRCLE_PX = 30;
const ICON_PX = 20;
const STEP_GAP = 2.5;

const MembershipInviteHowItWorksBlock: React.FC<
  MembershipInviteHowItWorksBlockProps
> = ({ steps, sx }) => {
  const circleSx = {
    alignItems: "center",
    bgcolor: COLORS.LIGHT_GRAY,
    borderRadius: "50%",
    display: "flex",
    flexShrink: 0,
    height: CIRCLE_PX,
    justifyContent: "center",
    mt: -0.5,
    width: CIRCLE_PX
  } as const;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: STEP_GAP,
        ...sx
      }}
    >
      {steps.map((step) => (
        <Box
          key={step.title}
          sx={{ alignItems: "flex-start", display: "flex", gap: 1.5 }}
        >
          <Box sx={circleSx}>
            <Box
              alt=""
              aria-hidden
              component="img"
              height={ICON_PX}
              src={step.icon}
              width={ICON_PX}
            />
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography
              component="h3"
              variant="body_strong_black"
              sx={{ m: 0, mb: 0.5 }}
            >
              {step.title}
            </Typography>
            <Typography
              component="div"
              variant="body2"
              sx={{ color: COLORS.DARK_GRAY, lineHeight: 1.5, m: 0 }}
            >
              {step.body}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default MembershipInviteHowItWorksBlock;
